import { Controller } from "@hotwired/stimulus"
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

export default class extends Controller {
  
  static values = { businessHours: Array,
                    events: Array }
  
  connect() {
    let daily = new Calendar(this.element, {
      plugins: [ dayGridPlugin, timeGridPlugin, listPlugin ],
      initialView: 'timeGridWeek',
      headerToolbar: {
        left: 'prev',
        center: 'title',
        right: 'next'
      },
      eventClick: function(info) {
        if (info.event.url) {
          window.open(info.event.url);
          return false; // Prevent the default behavior of navigating to the event's URL
        }
      },
    
      events: this.eventsValue,
      businessHours: this.businessHoursValue,
    });
    daily.render();
  }
}
